export const FETCH_FORMATION_BOOKMARKS_REQUEST = "FETCH_FORMATION_BOOKMARKS_REQUEST";
export const FETCH_FORMATION_BOOKMARKS_SUCCESS = "FETCH_FORMATION_BOOKMARKS_SUCCESS";
export const FETCH_FORMATION_BOOKMARKS_FAIL = "FETCH_FORMATION_BOOKMARKS_FAIL";

export const TOGGLE_FORMATION_BOOKMARK_REQUEST = "TOGGLE_FORMATION_BOOKMARK_REQUEST";
export const TOGGLE_FORMATION_BOOKMARK_SUCCESS = "TOGGLE_FORMATION_BOOKMARK_SUCCESS";
export const TOGGLE_FORMATION_BOOKMARK_FAIL = "TOGGLE_FORMATION_BOOKMARK_FAIL";

export const fetchFormationBookmarksRequest = (campagneId) => ({
    type: FETCH_FORMATION_BOOKMARKS_REQUEST,
    payload: { campagneId },
});

export const fetchFormationBookmarksSuccess = (campagneId, data) => ({
    type: FETCH_FORMATION_BOOKMARKS_SUCCESS,
    payload: { campagneId, data },
});

export const fetchFormationBookmarksFail = (campagneId, error) => ({
    type: FETCH_FORMATION_BOOKMARKS_FAIL,
    payload: { campagneId, error },
});

export const toggleFormationBookmarkRequest = (payload) => ({
    type: TOGGLE_FORMATION_BOOKMARK_REQUEST,
    payload,
});

export const toggleFormationBookmarkSuccess = (data) => ({
    type: TOGGLE_FORMATION_BOOKMARK_SUCCESS,
    payload: data,
});

export const toggleFormationBookmarkFail = (error) => ({
    type: TOGGLE_FORMATION_BOOKMARK_FAIL,
    payload: error,
});
